<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          responsive
          striped
          hover
          :fields="fields"
          :items="items"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:cell(action)="{ item }">
            <div class="container">
              <font-awesome-icon
                class="pointer"
                icon="trash-alt"
                @click="onDelete(item)"
              />
            </div>
          </template>
        </b-table>
        <p class="tw-text-red-500" v-if="v.form.productPriceManage.$error">
          กรุณาสร้างรอบเวลา
        </p>
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
export default {
  name: "TableScheduleTab",

  props: {
    items: {
      type: Array,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "ชื่อ",
          class: "w-50px text-nowrap",
        },
        {
          key: "timeFrom",
          label: "เวลาเริ่มต้น",
          class: "w-50px text-nowrap",
        },
        {
          key: "numberOfRound",
          label: "จำนวนรอบ",
          class: "w-50px text-nowrap",
        },
        {
          key: "action",

          class: " text-nowrap",
        },
      ],
      rows: 0,

      isBusy: false,
    };
  },
  methods: {
    onDelete(val) {
      const { index } = val;
      this.items.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped></style>
